import React, { useContext, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { AuthContext } from "../../context/AuthContext";

// Layout for /admin/*. Gated to Django staff users (profile.is_staff).
// Non-staff are bounced home. A simple sub-tab bar provides navigation since
// the primary Navbar has no admin mode.

const TABS = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/advisors", label: "Advisors" },
  { to: "/admin/plans", label: "Plans" },
  { to: "/admin/tickets", label: "Support Tickets" },
  { to: "/admin/research", label: "Research Desk" },
];

const AdminShell = () => {
  const { profile, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!profile) return;
    if (!profile.is_staff) {
      navigate("/", { replace: true });
    }
  }, [loading, profile, navigate]);

  if (loading || !profile) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-b dark:from-gray-900 dark:via-gray-950 dark:to-black">
        <Navbar />
      </div>
    );
  }

  if (!profile.is_staff) return null;

  return (
    <div className="min-h-screen pt-28 bg-gray-50 text-gray-900 dark:bg-gradient-to-b dark:from-gray-900 dark:via-gray-950 dark:to-black dark:text-white">
      <Navbar />
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 pt-4 pb-12 animate-fadeIn">
        <div className="flex flex-wrap items-center gap-x-1 gap-y-1 mb-6 border-b border-gray-200 dark:border-white/10">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `px-3 py-2 sm:px-4 sm:py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                  isActive
                    ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
                    : "border-transparent text-gray-500 hover:text-gray-800 dark:hover:text-gray-200"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default AdminShell;
